import React, { useEffect } from "react";
import "./Assets/css/_fonts/_open_sans.css"; // font had to be imported here instead of index.html because of file reference paths
import "./Assets/css/_fonts/_questrial.css"; // font had to be imported here instead of index.html because of file reference paths
import "./Assets/css/_fonts/_montserrat.css"; // font had to be imported here instead of index.html because of file reference paths
import "./Assets/css/_fonts/_adellesanssage.css";
import "./Assets/css/_fonts/_poppins.css";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "./store";
import { Routes } from "./Routes";
import Cookies from "universal-cookie";
import * as ConfigurationActions from "./store/configurationService/actions";

const App = () => {
    const partnerCustomCSSPath = useSelector((state: ApplicationState) => {
        if (state.configurationState && state.configurationState.configuration && state.configurationState.configuration.partnerConfig) {
            return state.configurationState.configuration.partnerConfig.styleSheetSrc;
        }

        return null;
    });
    const hasSontiqBrand = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.hasSontiqBrand
            ? state.configurationState.configuration.partnerConfig.hasSontiqBrand === "true"
                ? true
                : false
            : false
    );
    const partnerProviderEzs = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerProvider
            ? state.configurationState.configuration.partnerConfig.partnerProvider === "EZS"
                ? true
                : false
            : false
    );
    const partnerFavIconURL: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.faviconURL
            ? state.configurationState.configuration.partnerConfig.faviconURL
            : ""
    );
    const partnerProvider = useSelector((state: ApplicationState) => {
        if (
            state.configurationState &&
            state.configurationState.configuration &&
            state.configurationState.configuration.partnerConfig &&
            state.configurationState.configuration.partnerConfig.partnerProvider === "IDF"
        ) {
            return "IDF";
        }
        return "EZS";
    });
    const dispatch = useDispatch();
    const renderSiteFavIcon = () => {
        if (partnerFavIconURL) {
            const link = document.getElementById("favicon-icon-dynamic") as HTMLLinkElement;
            if (link) {
                link.type = "image/x-icon";
                link.rel = "shortcut icon";
                link.href = partnerFavIconURL;
                document.getElementsByTagName("head")[0].appendChild(link);
            }
            return;
        }

        if (hasSontiqBrand) {
            const link = document.getElementById("favicon-icon-dynamic") as HTMLLinkElement;
            if (link) {
                link.type = "image/x-icon";
                link.rel = "shortcut icon";
                link.href = "https://www.sontiq.com/wp-content/themes/sontiq/favicon.ico";
                document.getElementsByTagName("head")[0].appendChild(link);
            }
            return;
        }
        if (partnerProviderEzs) {
            const link = document.getElementById("favicon-icon-dynamic") as HTMLLinkElement;
            if (link) {
                link.type = "image/x-icon";
                link.rel = "shortcut icon";
                link.href = "images/ezsfavicon.ico";
                document.getElementsByTagName("head")[0].appendChild(link);
            }
        }
    };

    useEffect(() => {
        renderSiteFavIcon();
        if (partnerCustomCSSPath) {
            var head = document.head;
            var link = document.createElement("link");
            link.type = "text/css";
            link.rel = "stylesheet";
            link.href = partnerCustomCSSPath;
            head.appendChild(link);

            return () => {
                let dynamicPartnerCSSLinkCount = 0;
                const MAXIMUM_ALLOWED_DYNAMIC_CSS_LINK = 1;
                const linkTags = document.getElementsByTagName("link");
                for (let index = 0; index < linkTags.length; index++) {
                    if (linkTags[index].href && linkTags[index].href.endsWith(partnerCustomCSSPath)) {
                        dynamicPartnerCSSLinkCount++;
                    }
                }

                if (dynamicPartnerCSSLinkCount > MAXIMUM_ALLOWED_DYNAMIC_CSS_LINK) {
                    head.removeChild(link);
                }
            };
        }
    }, [partnerCustomCSSPath, partnerProvider]);
    useEffect(() => {
        setCidData();
    }, []);
    const cookies = new Cookies();

    function setCidData() {
        const query = new URLSearchParams(window.location.search);

        let channel: any = query.get("channel");
        let cid: any = query.get("cid");

        if (cid && channel && channel.toLowerCase() === "paid") {
            const expirationDate = new Date();
            expirationDate.setMonth(expirationDate.getMonth() + 6);

            cookies.set("channel", channel, { path: "/", expires: expirationDate });
            cookies.set("cid", cid, { path: "/", expires: expirationDate });
        } else {
            dispatch(ConfigurationActions.actionCreators.setUnpaidCidData(cid, channel));
        }
    }

    return <Routes />;
};

export default App;
